/**
 * What state an itinerary is in, for display.
 *
 * WHY THIS IS ITS OWN MODULE
 * --------------------------
 * It lived inline in ItineraryList as `it.status ? 'Pending' : 'Confirmed'`.
 * An itinerary has no top-level `status`: `createItinerary` writes `finalized`,
 * `schedule`, `bookings` and `travelers`, and the only `status` in the whole
 * document is nested at `bookings.accommodation.status`. The read was therefore
 * permanently `undefined`, permanently took the false branch, and every trip in
 * the list showed a green "Confirmed" from the moment it was created.
 *
 * `finalized` is the only state an itinerary actually carries — written false by
 * createItinerary and flipped by finalizeItinerary.
 *
 * "CONFIRMED" MEANS FINALISED HERE, NOT PROVIDER-ACCEPTED
 * -------------------------------------------------------
 * Product decision, made deliberately. Note that nothing writes a provider's
 * acceptance back to the itinerary: `bookings.accommodation.status` is set to
 * "pending" by updateItineraryAccommodation and never updated again, because
 * the provider console confirms the separate `bookings` document. So this badge
 * reflects only that the traveller pressed "Finalise Itinerary".
 *
 * If a real provider-side confirmation is ever surfaced to travellers, this is
 * the function to change, and it will need that booking status plumbed back
 * onto the itinerary first — a green "Confirmed" against a booking a provider
 * has since declined is worse than no badge at all.
 *
 * "Pending" likewise means the traveller has not finalised it yet, not that
 * anyone is waiting on a provider.
 */
export function itineraryStatus(itinerary) {
  return itinerary?.finalized
    ? { label: 'Confirmed', color: 'success' }
    : { label: 'Pending', color: 'default' };
}
